export * from "./axiosConfig";
import dayjs from "dayjs";

export const formatMultiResultSet = (resultSet, dataSources) => {
  const timestampIndex = resultSet.timestamp;
  const dataset = [...resultSet.dataset];
  const timestamps = dataset.map((d) => dayjs(d.splice(timestampIndex, 1)[0]).unix());
  const data = dataSources.map((ds, index) => dataset.map((item) => item[index]));

  return [timestamps, ...data];
};

export const formatResultSet = (resultSet) => {
  const timestampIndex = resultSet.timestamp;
  const dataset = [...resultSet.dataset];
  const timestamps = dataset.map((d) => dayjs(d.splice(timestampIndex, 1)[0]).unix());
  const data = dataset.flat();

  return [timestamps, data];
};

export const formatResultSetMutliValues = (resultSet, asset) => {
  // console.log("MinMaxChart resultSet", resultSet);
  const timestampIndex = resultSet.timestamp;
  const dataset = [...resultSet.dataset];
  // console.log("MinMaxChart dataset", dataset);
  const results = [];
  const timestamps = dataset.map((d) => {
    return dayjs(d.splice(timestampIndex, 1)[0]).unix();
  });

  results[0] = timestamps;
  results[1] = dataset.flat();

  if (asset?.maximumValue != null && asset?.minimumValue != null) {
    results[2] = [];
    results[3] = [];
    dataset.map((d) => {
      results[2].push(asset?.maximumValue);
      results[3].push(asset?.minimumValue);
    });
  }
  // console.log("MinMaxChart preparedData", results);
  return results;
};

export const splitTimeInterval = (timeInterval) => {
  const match = timeInterval.match(/(\d+)(\w+)/);
  return {
    value: parseInt(match[1], 10),
    unit: match[2],
  };
};

export const formatValue = (value, options = {}) => {
  if (value == null) {
    return null;
  }

  console.log("formatValue options", options);
  console.log("formatValue value", value);

  if (
    options?.transformNegativeToZero === true &&
    options?.fields?.includes(options?.dataSource) &&
    value < 0
  ) {
    return 0;
  }

  if (
    options?.transformValue &&
    ["xGreenLED", "xYellowLED", "xRedLED", "xBuzzer"].includes(options?.dataSource)
  ) {
    if (value === 0) {
      return "OFF";
    }
    if (value === 1) {
      return "ON";
    }
  }

  try {
    return Number(value)?.toFixed(2);
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const getSeconds = (timeInterval, start, end, timeKey) => {
  let seconds = 0;

  // Define the two dates
  const date1 = dayjs(start);
  const date2 = dayjs(end);

  // Calculate the difference in seconds

  seconds = date2.diff(date1, "second");

  return seconds;
};

export const convertSeconds = (seconds) => {
  if (!seconds) return null;

  const months = seconds / (86400 * 30.44);
  const days = seconds / 86400;
  const hours = seconds / 3600;
  const minutes = seconds / 60;

  if (months >= 1) {
    return { value: months.toFixed(2), unit: "months" };
  } else if (days >= 1) {
    return { value: days.toFixed(2), unit: "days" };
  } else if (hours >= 1) {
    return { value: hours.toFixed(2), unit: "hrs" };
  } else if (minutes >= 1) {
    return { value: minutes.toFixed(2), unit: "mins" };
  } else {
    return { value: seconds, unit: "seconds" };
  }
};

export const getPercentage = (totalRecords, records) => {
  if (!records || !totalRecords) return 0;

  if (totalRecords === 0) {
    return 100;
  }

  if (records === 0) {
    return 0;
  }

  let percentage = parseFloat((records / totalRecords) * 100);

  if (isNaN(percentage)) {
    return 0;
  }

  if (percentage > 100) {
    percentage = 100;
  }

  return percentage.toFixed(2);
};

export const calculateSampling = (start, end) => {
  const diff = end.diff(start, "seconds");
  if (diff >= 180 * 24 * 60 * 60) {
    return "6h";
  } else if (diff >= 90 * 24 * 60 * 60) {
    return "4h";
  } else if (diff >= 30 * 24 * 60 * 60) {
    return "3h";
  } else if (diff >= 15 * 24 * 60 * 60) {
    return "2h";
  } else if (diff >= 10 * 24 * 60 * 60) {
    return "40m";
  } else if (diff >= 5 * 24 * 60 * 60) {
    return "30m";
  } else if (diff >= 24 * 60 * 60) {
    return "5m";
  } else if (diff >= 12 * 60 * 60) {
    return "60s";
  } else if (diff >= 6 * 60 * 60) {
    return "30s";
  } else if (diff >= 3 * 60 * 60) {
    return "10s";
  } else if (diff >= 60 * 60) {
    return "5s";
  } else if (diff >= 15 * 60) {
    return "1s";
  } else if (diff >= 5 * 60) {
    return "1s";
  } else {
    return "1s";
  }
};

export const isDataSourceEnabled = (dataSource, userAssets) => {
  const assets = userAssets ?? [];
  const asset = assets?.find((asset) => asset.dataSource == dataSource);
  return Boolean(asset?.status);
};

export const getLabel = (labels = {}, value) => {
  const label = labels?.find((l) => l.value === value);
  return label?.label || "Unknown";
};

// base64Helpers.js

// Encode an ASCII-safe string (like an ID) to URL-safe Base64
export const encode = (id) => {
  try {
    return btoa(id).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""); // Remove padding
  } catch (e) {
    console.error("Failed to encode ID:", e);
    return null;
  }
};

// Decode a URL-safe Base64 string back to the original ID
export const decode = (encodedId) => {
  try {
    // Restore padding and revert to standard Base64
    let base64 = encodedId.replace(/-/g, "+").replace(/_/g, "/");

    // Add padding back if needed
    while (base64.length % 4 !== 0) {
      base64 += "=";
    }

    return atob(base64);
  } catch (e) {
    console.error("Failed to decode ID:", e);
    return null;
  }
};

export const getPriorityStyle = (priority) => {
  switch (priority) {
    case 0:
      return { bgcolor: "#aaff3f4f", color: "#5c9d07", borderRadius: 6 }; // Green
    case 1:
      return { bgcolor: "#fbcf3357", color: "#a48b25", borderRadius: 6 }; // Orange
    case 2:
      return { bgcolor: "#ff63474d", color: "#D03E2A", borderRadius: 6 }; // Red
    case 3:
      return { bgcolor: "#ff634785", color: "#6e0d00", borderRadius: 6 }; // red/Blue
    default:
      return { bgcolor: "info.main", color: "#fff", borderRadius: 6 }; // Blue
  }
};

export const getStatusStyle = (status) => {
  switch (status) {
    case 0:
      return { bgcolor: "#aaff3f4f", color: "#5c9d07", borderRadius: 6 }; // Green
    case 1:
      return { bgcolor: "#00cfff3b", color: "#2dafcded", borderRadius: 6 }; // Blue
    case 2:
      return { bgcolor: "#fbcf3357", color: "#a48b25", borderRadius: 6 }; // Orange/Yellow
    case 4:
      return { bgcolor: "#6c757d40", color: "#00000085", borderRadius: 6 }; // Gray
    default:
      return { bgcolor: "secondary.main", color: "#fff", borderRadius: 6 }; // Default Blue
  }
};

export const getInspectionStatusStyle = (status) => {
  switch (status) {
    case 0:
      return { bgcolor: "#fbcf3357", color: "#a48b25", borderRadius: 6 }; // Orange/Yellow
    case 1:
      return { bgcolor: "#aaff3f4f", color: "#5c9d07", borderRadius: 6 }; // Green
    case 2:
      return { bgcolor: "#ff63474d", color: "#D03E2A", borderRadius: 6 }; // Red
    default:
      return { bgcolor: "info.main", color: "#fff", borderRadius: 6 }; // Blue
  }
};

const channelIdToColumnName = {
  EN03: {
    1: "rCurrent1",
    2: "rCurrent2",
    3: "rCurrent3",
    4: "rCurrent4",
    5: "rCurrent5",
    6: "rCurrent6",
    7: "rCurrent7",
    8: "rCurrent8",
    9: "rCurrent9",
    10: "rCurrent10",
    11: "rCurrent11",
    12: "rCurrent12",
  },
  EN01: {
    0: "rAmps",
  },
  EN02: {
    0: "rAmps",
  },
  CP01: {
    0: "rCurrent",
    1: "rCurrent2",
    2: "rCurrent3",
    3: "rCurrent4",
  },
};

export const getChannelIdFromColumnName = (tableName, columnName) => {
  const table = channelIdToColumnName[tableName];
  if (!table) return null;

  for (const [id, colName] of Object.entries(table)) {
    if (colName === columnName) {
      return parseInt(id, 10);
    }
  }

  return null; // Not found
};

export const getColumnNameFromChannelId = (tableName, channelId) => {
  const table = channelIdToColumnName[tableName];
  if (!table) return null;

  return table[channelId] || null;
};

export const getDueDateStyle = (status) => {
  if (status === 3 || status === 4) {
    return { backgroundColor: "transparent", borderColor: "transparent", textColor: "red" };
  } else {
    return { backgroundColor: "transparent", borderColor: "transparent", textColor: "green" };
  }
};

export const getAssetMaintenanceStyle = (status) => {
  switch (status) {
    case 0:
      return { bgcolor: "#0000001a", color: "#333333", borderRadius: 6 }; // Soft black/gray
    case 1:
      return { bgcolor: "#aaff3f4f", color: "#5c9d07", borderRadius: 6 }; // Green
    case 2:
      return { bgcolor: "#fbcf3357", color: "#a48b25", borderRadius: 6 }; // Orange
    case 3:
      return { bgcolor: "#ff634785", color: "#6e0d00", borderRadius: 6 }; // red/Blue
    case 4:
      return { bgcolor: "#aaff3f4f", color: "#5c9d07", borderRadius: 6 }; // Green
    default:
      return { bgcolor: "info.main", color: "#fff", borderRadius: 6 }; // Blue
  }
};

export function convertHoursToYMD(totalHours) {
  if (totalHours < 0) {
    throw new Error("Input hours cannot be negative.");
  }

  const hoursInDay = 24;
  const daysInYear = 365; // Average days in a year
  const monthLengths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // Days in each month (non-leap year)

  // Calculate years
  const years = Math.floor(totalHours / (daysInYear * hoursInDay));
  let remainingHours = totalHours % (daysInYear * hoursInDay);

  // Determine leap years and adjust February's length
  let leapYears = 0;
  for (let i = 0; i <= years; i++) {
    if ((i % 4 === 0 && i % 100 !== 0) || i % 400 === 0) {
      leapYears++;
    }
  }

  // Calculate remaining days
  let days = Math.floor(remainingHours / hoursInDay);
  remainingHours %= hoursInDay;

  // Calculate months based on remaining days, considering leap years
  let months = 0;
  let currentMonthIndex = 0;
  while (days > monthLengths[currentMonthIndex]) {
    days -= monthLengths[currentMonthIndex];
    currentMonthIndex++;
    months++;
    if (currentMonthIndex === 1 && leapYears > 0) {
      days--; // Account for extra day in February during leap years
      leapYears--;
    }
  }

  return {
    years: years,
    months: months,
    days: days,
    hours: remainingHours,
  };
}

function formatTimeComponents(years, months, days, hours) {
  const parts = [];

  if (years > 0) {
    parts.push(`${years} ${years === 1 ? "year" : "years"}`);
  }

  if (months > 0) {
    parts.push(`${months} ${months === 1 ? "month" : "months"}`);
  }

  if (days > 0) {
    parts.push(`${days} ${days === 1 ? "day" : "days"}`);
  }

  if (hours > 0) {
    parts.push(`${hours} ${hours === 1 ? "hour" : "hours"}`);
  }

  if (parts.length === 0) {
    return "0 hours"; // Handle the case where no time units are present
  }

  if (parts.length === 1) {
    return parts[0];
  }

  if (parts.length === 2) {
    return `${parts[0]} and ${parts[1]}`;
  }

  const lastPart = parts.pop();
  return `${parts.join(", ")} and ${lastPart}`;
}

export function formatHoursToYMDString(totalHours) {
  const { years, months, days, hours } = convertHoursToYMD(totalHours);
  return formatTimeComponents(years, months, days, hours);
}

export const getAssetLabel = (asset) => {
  if (!asset) return null;

  if (asset.assetCategoryId == 3) {
    return <>{asset.label}</>;
  }

  return (
    <>
      {Boolean(asset.deviceStyle?.sFriendly_Name)
        ? asset.deviceStyle?.sFriendly_Name
        : asset.deviceNumber}
    </>
  );
};

export const comparisonOperatorToString = (operator) => {
  switch (operator) {
    case "==":
      return "Equal To";
    case "!=":
      return "Not Equal To";
    case ">":
      return "Greater Than";
    case "<":
      return "Less Than";
    case ">=":
      return "Greater Than or Equal To";
    case "<=":
      return "Less Than or Equal To";
    default:
      return null;
  }
};
